/**
 * Kadmin Project Declaration File
 *
 * Central configuration for the project. All project-specific
 * settings are defined here and consumed by the Kadmin framework.
 */
const kadminConfig = {
  // Project identity
  name: "Kadmin Starter",
  version: "1.0.0",
  description: "A new project powered by Kadmin",

  // Modules to enable (maps to route groups and sidebar sections)
  modules: [
    "auth", // Login, Signup, Reset (always required)
    "dashboard", // Dashboard with widgets
    "samples", // Sample CRUD module (reference implementation)
    // 'billing',        // Stripe billing (uncomment to enable)
    // 'notifications',  // Push notifications (uncomment to enable)
  ],

  // Internationalization
  defaultLanguage: "en",
  supportedLanguages: ["en", "fr"],

  // Theme overrides
  theme: {
    brandName: "Kadmin",
    primaryColor: "#1976d2",
    secondaryColor: "#9c27b0",
    logo: "/images/logo.png",
    logoDark: "/images/logo-dark.png",
    favicon: "/favicon.ico",
  },

  // Roles (must match server/config/roleConfig.js)
  roles: ["admin", "user"],
  defaultRole: "user",

  // API configuration
  api: {
    baseUrl: process.env.REACT_APP_API_URL || "/api",
    timeout: 30000,
  },

  // Feature toggles
  features: {
    darkMode: true,
    rtl: false,
    impersonation: false,
    apiKeys: false,
    sso: true,
  },
};

export default kadminConfig;
